(function($) {

	$.fn.msxiPanel = function() {

		return this.each(function() {
			var $this = $(this);

            // If there is more than one legend on the panel (created by different plugins) then merge them together
            $this.find('.panel-legend').filter(':first').append($this.find('.panel-legend').not(':first').contents());

            $this.find('.panel-legend').each(function(){
                var legendWidth = $this.find('.panel-legend').outerWidth(true);
                $this.find('.panel-header').css('padding-right', legendWidth-5);
            });

            var $panelContent = $this.is('.panel-content') ? $this : $this.find('> .panel-content');
            var href= $panelContent.data('href');

            if(href && !$panelContent.hasClass('panel-content-loading')) {
                if($panelContent.closest('.ui-tabs-panel').length > 0) {
                    if($panelContent.is(':visible')) {
                        loadFromHref($panelContent, href);
                    }
                    else {
                        var onTabsActivate = function(event, ui){
                            if(ui.newPanel.attr('id') === $panelContent.closest('.ui-tabs-panel').attr('id')) {
                                loadFromHref($panelContent, href);
                                $panelContent.closest('.ui-tabs').off('tabsactivate', onTabsActivate);
                            }
                        };
                        $panelContent.closest('.ui-tabs').on('tabsactivate', onTabsActivate);
                    }
                }
                else {
                    loadFromHref($panelContent, href);
                }
            }
        });
	};

	function loadFromHref($panelContent, href) {
        if (!$panelContent.hasClass('panel-content-loading')) {
            var classes = [];
            var classNames = $panelContent.attr('class').split(' ');
            $.each(classNames, function (i, className) {
                if (className.indexOf('panel-content-') === 0) {
                    classes.push(className);
                    $panelContent.removeClass(className);
                }
            });
            $panelContent.addClass('panel-content-loading');
            $('<div class="loading-spinner-overlay" />').appendTo($panelContent);
            var $spinner = $('<div class="loading-spinner"/>').appendTo($panelContent);
            var spinner = Spinners.create($spinner, $.fn.msxitabs.defaults.spinner).play();
            $panelContent.load(href, function () {
                $.each(classes, function (i, className) {
                    $panelContent.addClass(className);
                });
                $panelContent.msxiinit();
                spinner.remove();
                $spinner.remove();

                $panelContent.trigger('panel-loaded');

                $panelContent.removeClass('panel-content-loading');
            });

            initPanelPageNavigation($panelContent);
            initPanelForm($panelContent);
        }

    }

    function initPanelForm($panelContent) {
        $panelContent.on('submit', 'form', function() {
            var $enabledSubmits = $panelContent.find(".ui-button:submit:enabled").button('disable');
            var $form = $(this);

            $('<div class="loading-spinner-overlay" />').appendTo($panelContent);
            var $spinner = $('<div class="loading-spinner"/>').appendTo($panelContent);
            var spinner = Spinners.create($spinner, $.fn.msxitabs.defaults.spinner).play();

            $.ajax({
                type: $form.attr("method"),
                url: $form.attr("action"),
                data: $form.serialize(),
                success: function(data)
                {
                    $panelContent.html(data);

                    $panelContent.msxiinit();
                    spinner.remove();
                    $spinner.remove();

                    $panelContent.trigger('panel-loaded');

                    try {
                        $enabledSubmits.filter('.ui-button').button('enable');
                    } catch (e) {
                        // Using try block because for unknown reason this sometimes fails with:
                        // "Uncaught Error: cannot call methods on button prior to initialization; attempted to call method 'enable'"
                    }
                }
            });
            return false;
        });
    }

    function initPanelPageNavigation($panelContent)
    {
        $panelContent.on('click', '.page-navigation a, th.sortable, form a.button', function(){
            var href;
            if ($(this).is('a')) {
                href = $(this).attr('href');
            } else {
                href = $(this).find("a").attr('href');
            }
            if (href) {
                $('<div class="loading-spinner-overlay" />').appendTo($panelContent);
                var $spinner = $('<div class="loading-spinner"/>').appendTo($panelContent);
                var spinner = Spinners.create($spinner, $.fn.msxitabs.defaults.spinner).play();
                $panelContent.load(href, function () {
                    $panelContent.msxiinit();
                    spinner.remove();
                    $spinner.remove();

                    $panelContent.trigger('panel-loaded');
                });
                return false;
            }
        });
    }

})(jQuery);